// extracted by mini-css-extract-plugin
export var baseButton = "_wc-0";
export var controlsArrowKeys = "_wc-1";
export var controlsResetButton = "_wc-2";
export var lightGameButton = "_wc-4 _wc-0";
export var playAgainButton = "_wc-5 _wc-0";
export var startGameButton = "_wc-3 _wc-0";